import React from "react";
import { mergeDeviceStatus } from "../lib/deviceFlags";
import { getEffectiveRtmpPushUrl } from "../lib/streamUrls";

const STREAM_PROTOCOLS = ["webrtc", "hls", "rtsp", "llhls"];

function StatusPill({ label, on, offLabel = "off" }) {
  return (
    <span className={`status-pill ${on ? "status-pill--on" : "status-pill--off"}`}>
      {label}: {on ? "yes" : offLabel}
    </span>
  );
}

export default function DeviceList({
  devices,
  streamModes,
  workerStatus,
  onChangeStreamMode,
  onOpen,
  onEdit,
  onDelete,
  onAdd,
  onToggleActive,
  onToggleAi,
}) {
  return (
    <div className="device-list">
      <div className="title-row">
        <div>
          <h3>Device Sensors</h3>
          <p className="section-subtitle">
            Cameras, RTSP source, RTMP platform ingest, and live pipeline status
          </p>
        </div>
        <button type="button" className="primary-btn" onClick={onAdd}>
          Add Device
        </button>
      </div>

      <div className="device-grid">
        {devices.map((dev) => {
          const name = dev.deviceName || dev.name || `Device ${dev.id}`;
          const source = dev.ipAddress || "—";
          const injection = getEffectiveRtmpPushUrl(dev) || "—";
          const selectedMode = streamModes[dev.id] || "webrtc";
          const st = mergeDeviceStatus(dev, workerStatus);

          return (
            <div key={dev.id} className="device-item">
              <div className="device-card-head">
                <div className="device-name">{name}</div>
                <span className="device-id-badge">#{dev.id}</span>
              </div>

              <div className="device-status-row">
                <StatusPill label="API active" on={st.apiActive} />
                <StatusPill label="RTSP ingest" on={st.rtspIngesting} offLabel="no" />
                <StatusPill label="RTMP out" on={st.rtmpPublishing} offLabel="no" />
                <StatusPill label="AI" on={st.aiProcessing} offLabel="off" />
              </div>

              <div className="device-meta-row">
                <span className="meta-key">RTSP source</span>
                <span className="meta-value" title={source}>
                  {source}
                </span>
              </div>

              <div className="device-meta-row">
                <span className="meta-key">RTMP ingest</span>
                <span className="meta-value" title={injection}>
                  {injection}
                </span>
              </div>

              <div className="device-meta-row">
                <span className="meta-key">Stream</span>
                <select
                  className="stream-select"
                  value={selectedMode}
                  onChange={(e) => onChangeStreamMode(dev.id, e.target.value)}
                >
                  {STREAM_PROTOCOLS.map((mode) => (
                    <option key={mode} value={mode}>
                      {mode.toUpperCase()}
                    </option>
                  ))}
                </select>
              </div>

              <div className="device-toggle-row">
                <label className="toggle-chip">
                  <input
                    type="checkbox"
                    checked={st.apiActive}
                    onChange={(e) => onToggleActive(dev, e.target.checked)}
                  />
                  <span>isActive (run worker)</span>
                </label>
                <label className="toggle-chip">
                  <input
                    type="checkbox"
                    checked={st.apiAi}
                    onChange={(e) => onToggleAi(dev, e.target.checked)}
                  />
                  <span>isAiProcess (analytics)</span>
                </label>
              </div>

              <div className="actions-row card-actions">
                <button type="button" onClick={() => onOpen(dev)}>
                  Open
                </button>
                <button type="button" onClick={() => onEdit(dev)}>
                  Edit
                </button>
                <button type="button" className="danger" onClick={() => onDelete(dev)}>
                  Delete
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
